// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-10-02 00:28:05 +0200 (Thu, 02 Oct 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156877 $
//  Purpose   : react components for debugging
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Table, Button, Header, Icon, Message, Label} from 'semantic-ui-react'

// ---Framework imports
import connect from 'uix/connect'
import {mapItems, rstrip, isString} from 'ldash'
import {uix, Actions} from 'uix/registries'
import log from 'uix/logging'
import {KNOWN_SERVERS, LOCAL_HOSTNAME} from 'uix/deploy'
import {HeaderSegment, XMenu} from 'uix/components'
import {useState, useSelector, useActions, useEffect} from 'uix/hooks'

// ---Local imports

// ---Globals
export const ServerChooser = ({message}) => {
  // debug actions
  let [getApiAvailability, switchApiUrl] = useActions(['getApiAvailability', 'switchApiUrl'])
  let apiAvailability = useSelector(root => root.debug.apiAvailability)

  let [filter, setFilter] = useState('vis')

  let filtered_servers = KNOWN_SERVERS.filter(
    url => filter == '*' || (filter.length > 2 && url.includes(filter))
  )

  useEffect(() => {
    getApiAvailability(filtered_servers)
  }, [filter])

  apiAvailability = apiAvailability || {}

  let availability = url => {
    let bColor = 'grey'
    let iColor = 'grey'
    if (apiAvailability[url] == true) {
      iColor = 'green'
      bColor = 'green'
    } else if (apiAvailability[url] == false) {
      bColor = 'grey'
      iColor = 'red'
    }
    return (
      <Button size="small" color={bColor} basic compact onClick={() => switchApiUrl(url)}>
        <Icon name="plug" color={iColor} /> {url}
      </Button>
    )
  }
  let ApiButton = ({name, href}) => (
    <Button secondary compact size="small" as="a" href={href} target="_api" content={name} />
  )

  let rows = servers =>
    servers.map(url => (
      <Table.Row key={url}>
        <Table.Cell>{availability(url)}</Table.Cell>
        <Table.Cell>
          <ApiButton name="init" href={`${url}/api/init`} />
          <ApiButton name="dconfig" href={`${url}/api/initDomain/dconfig`} />
          <ApiButton name="types" href={`${url}/api/initDomain/types`} />
          <ApiButton name="templating" href={`${url}/api/initDomain/templating`} />
        </Table.Cell>
      </Table.Row>
    ))

  let ServerTable = ({servers}) => (
    <Table celled compact size="small">
      <Table.Body>{rows(servers)}</Table.Body>
    </Table>
  )
  let menu = (
    <XMenu borderless>
      <XMenu.FilterInput
        autoFocus
        title="use * for all"
        defaultValue={filter}
        onValueChange={setFilter}
      />
    </XMenu>
  )
  return (
    <div style={{padding: '2em', fontSize: '0.8rem'}}>
      <HeaderSegment
        icon="fire extinguisher"
        header={message}
        subheader={`choose other Server for API - available: ${KNOWN_SERVERS.length}`}
        menu={menu}
      >
        {filtered_servers.length ? (
          <ServerTable servers={filtered_servers} />
        ) : (
          <Message info>No instances filtered.</Message>
        )}
      </HeaderSegment>
    </div>
  )
}
